import React, { useState } from "react";

export const formatDate = (d) => {

    var dt = new Date(d);
    const year  = dt.getFullYear();
    const month = (dt.getMonth() + 1).toString().padStart(2, "0");
    const day   = dt.getDate().toString().padStart(2, "0");
 
    return month+"/" +day+"/"+year;


}

export const formatDate2 = (d) => {

    var dt = new Date(d);
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const year  = dt.getFullYear();
    const month = (dt.getMonth() + 1).toString().padStart(2, "0");
    const day   = dt.getDate().toString().padStart(2, "0");
 
    return months[(month-1)]+" " +day+","+year;


}

export const formatTodayDate = () => {

    var dt = new Date();
    const year  = dt.getFullYear();
    const month = (dt.getMonth() + 1).toString().padStart(2, "0");
    const day   = dt.getDate().toString().padStart(2, "0");
 
    return month+"/" +day+"/"+year;


}


export const formatTodayDate2 = () => {

    var dt = new Date();
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const year  = dt.getFullYear();
    const month = (dt.getMonth() + 1).toString().padStart(2, "0");
    const day   = dt.getDate().toString().padStart(2, "0");
 
    return  months[(month-1)]+" " +day+","+year;


}

export const formatDateTime = (dt) => {


    dt = new Date(dt);
    const year  = dt.getFullYear();
    const month = (dt.getMonth() + 1).toString().padStart(2, "0");
    const day   = dt.getDate().toString().padStart(2, "0");
 
    return month+"/" +day+"/"+year;
}

export const formatTodayDateTime2 = () => {

    var dt = new Date();
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const year  = dt.getFullYear();
    const month = (dt.getMonth() + 1).toString().padStart(2, "0");
    const day   = dt.getDate().toString().padStart(2, "0");

    const ti = dt.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
  //  const min = dt.getMinutes().toString().padStart(2, "0");
  const time_zone = dt.toLocaleDateString(undefined, {day:'2-digit',timeZoneName: 'long' }).substring(4);
    return  months[(month-1)]+" " +day+","+year + " " + ti + " ("+time_zone+")" ;


}


export const addWorkDays = (startDate, days) => {
    if(isNaN(days)) {
        console.log("Value provided for \"days\" was not a number");
        return
    }

    if(!(startDate instanceof Date)) {
       startDate = new Date(startDate)
    }
    if(!(startDate instanceof Date)) {
        console.log("Value provided for \"startDate\" was not a Date object");
        return
    }
    // Get the day of the week as a number (0 = Sunday, 1 = Monday, .... 6 = Saturday)
    var dow = startDate.getDay();
    var daysToAdd = parseInt(days);
    // If the current day is Sunday add one day
    if (dow == 0)
        daysToAdd++;
    // If the start date plus the additional days falls on or after the closest Saturday calculate weekends
    if (dow + daysToAdd >= 6) {
        //Subtract days in current working week from work days
        var remainingWorkDays = daysToAdd - (5 - dow);
        //Add current working week's weekend
        daysToAdd += 2;
        if (remainingWorkDays > 5) {
            //Add two days for each working week by calculating how many weeks are included
            daysToAdd += 2 * Math.floor(remainingWorkDays / 5);
            //Exclude final weekend if remainingWorkDays resolves to an exact number of weeks
            if (remainingWorkDays % 5 == 0)
                daysToAdd -= 2;
        }
    }
    startDate.setDate(startDate.getDate() + daysToAdd);
    return startDate;
}
